import { forwardRef } from 'react';
import { AghanimIcon, IconBase } from '../IconBase';

export const Collapse: AghanimIcon = forwardRef(function CloseOutline({ ...rest }, ref) {
  return (
    <IconBase {...rest} viewBox="0 0 14 14" ref={ref}>
      <path
        d="M12.25 5.83333C12.25 6.1555 11.9888 6.41667 11.6667 6.41667L8.45833 6.41667C7.97508 6.41667 7.58333 6.02492 7.58333 5.54167L7.58333 2.33333C7.58333 2.01117 7.8445 1.75 8.16667 1.75C8.48883 1.75 8.75 2.01117 8.75 2.33333V5.25L11.6667 5.25C11.9888 5.25 12.25 5.51117 12.25 5.83333Z"
        fill="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M1.75 8.16667C1.75 7.8445 2.01117 7.58333 2.33333 7.58333H5.54167C6.02492 7.58333 6.41667 7.97508 6.41667 8.45833V11.6667C6.41667 11.9888 6.1555 12.25 5.83333 12.25C5.51117 12.25 5.25 11.9888 5.25 11.6667V8.75H2.33333C2.01117 8.75 1.75 8.48883 1.75 8.16667Z"
        fill="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </IconBase>
  );
});

Collapse.type = 'aghanim-icon';
